import React from 'react';
import CustomText from '../../../../Typography/CustomText/CustomText';

interface SiteKitSignPostSubtitleProps {
  children: React.ReactNode;
}
const SiteKitSignPostSubtitle = ({ children }: SiteKitSignPostSubtitleProps) => (
  <CustomText as="span" size="12" whiteSpace="nowrap" color="gray">
    {children}
  </CustomText>
);

SiteKitSignPostSubtitle.displayName = 'SiteKit.Header.SignPost.Subtitle';

export { SiteKitSignPostSubtitle, SiteKitSignPostSubtitleProps };
